import React, { useEffect, useState } from 'react';
import './scss/Header.scss';
import { useNavigate } from "react-router-dom";
import { useLocalDB } from "../contexts/LocalDBContext";

const DesignerCardInfoFull = ({ id }) => {
  const navigate = useNavigate();
  const { getStudioById, getPortfoliosByStudioId } = useLocalDB();
  const [studio, setStudio] = useState(null);
  const [portfolio, setPortfolio] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const services = [
    { name: "Дизайн-проект интерьера дома", cost: "от 900 ₽" },
    { name: "Авторский надзор в дизайне интерьеров", cost: "от 1500 ₽" },
    { name: "Трехмерная визуализация дизайна интерьера", cost: "от 2000 ₽" },
  ];


  useEffect(() => {
    const load = async () => {
      const data = await getStudioById(id);
      const portf = await getPortfoliosByStudioId(id);
      setStudio(data);
      setPortfolio(portf);
    };
    if (id) load();
  }, [id]);

  if (!studio) return null;

  return (
    <div className="card">
      <div className="user-card">
        <div className="row" style={{ cursor: "pointer" }}>
          <div onClick={() => navigate(`/designer/profile/${id}`)} className="col col-2 col-md-1">
            <img className="mx-auto d-block circle avatar" src={`/images/${studio.avatar}`} alt="" />
          </div>
          <div className="col" onClick={() => navigate(`/designer/profile/${id}`)}>
            <p>{studio.name}</p>
            <div>
              <span className="star-container">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd"
                    d="M6.61108 1.09924C6.8561 0.977662 7.14389 0.977662 7.38891 1.09924C7.60508 1.2065 7.71782 1.39497 7.77195 1.49199C7.8305 1.59692 7.89047 1.73151 7.95039 1.86601C7.95327 1.87248 7.95615 1.87894 7.95903 1.8854L9.00732 4.23715L11.589 4.50963C11.7355 4.52506 11.882 4.5405 11.9999 4.56376C12.1089 4.58526 12.323 4.63424 12.4918 4.80668C12.6831 5.00214 12.772 5.27584 12.7321 5.54645C12.6969 5.78518 12.5525 5.95064 12.477 6.03211C12.3953 6.12021 12.2858 6.21883 12.1764 6.31738L10.2479 8.05532L10.7866 10.5949C10.8171 10.7389 10.8477 10.883 10.8621 11.0023C10.8753 11.1126 10.8949 11.3314 10.783 11.5452C10.6562 11.7876 10.4234 11.9568 10.1537 12.0024C9.91581 12.0427 9.71381 11.9565 9.61299 11.9098C9.50396 11.8593 9.37635 11.7857 9.24882 11.7121L6.99999 10.4151L4.75116 11.7121C4.62364 11.7857 4.49603 11.8593 4.387 11.9098C4.28618 11.9565 4.08418 12.0427 3.84626 12.0024C3.57657 11.9568 3.34374 11.7876 3.21697 11.5452C3.10514 11.3314 3.12471 11.1126 3.13794 11.0023C3.15225 10.883 3.18285 10.7389 3.21342 10.5949L3.75207 8.05532L1.83936 6.3316C1.83411 6.32686 1.82885 6.32212 1.82359 6.31739C1.71419 6.21883 1.60472 6.12021 1.52302 6.03211C1.44748 5.95064 1.30307 5.78518 1.26786 5.54645C1.22795 5.27584 1.31688 5.00215 1.50822 4.80668C1.67703 4.63424 1.89112 4.58526 2.00012 4.56376C2.118 4.5405 2.26453 4.52506 2.41096 4.50963C2.418 4.50889 2.42504 4.50815 2.43208 4.5074L4.99267 4.23715L6.04096 1.8854C6.04384 1.87894 6.04672 1.87247 6.0496 1.866C6.10953 1.73151 6.16949 1.59692 6.22804 1.49199C6.28217 1.39497 6.39491 1.2065 6.61108 1.09924Z"
                    fill="#FE9402" />
                </svg>
                {studio.rating}
              </span>
              <span className="subscribers">{studio.subscribers} подписчиков</span>
            </div>
          </div>
        </div>

        {/* Превью портфолио (до 4 изображений) */}
        <div className="row images-container">
          {portfolio.slice(0, 4).map((p) => (
            <div className="col" key={p.id}>
              <img className="rounded mx-auto d-block img-fluid" src={`/images/${p.image1}`} alt="" />
            </div>
          ))}
        </div>

        {(expanded ? services : services.slice(0, 1)).map((service, idx) => (
          <div className="row justify-content-between services-container" key={idx}>
            <div className="col">
              <p>{service.name}</p>
            </div>
            <div className="col">
              <p className="cost">{service.cost}</p>
            </div>
          </div>
        ))}


        <div className="row">
          <div className="col col-md-12 col-12">
            <hr />
          </div>
          <div
            onClick={() => setExpanded(!expanded)}
            className="col col-md-12 col-12 more-click"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className={expanded ? "arrow rotated" : "arrow"}
              xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd"
                d="M10 13.3333C10.221 13.3333 10.433 13.2455 10.5893 13.0892L15.5893 8.08917C15.9147 7.76374 15.9147 7.2361 15.5893 6.91066C15.2638 6.58523 14.7362 6.58523 14.4108 6.91066L10 11.3214L5.58928 6.91066C5.26384 6.58523 4.7362 6.58523 4.41076 6.91066C4.08533 7.2361 4.08533 7.76374 4.41076 8.08917L9.41076 13.0892C9.56704 13.2455 9.77901 13.3333 10 13.3333Z"
                fill="#191A21" />
            </svg>
            {expanded ? "Скрыть" : "Показать полностью"}
            </div>
          <div className="col col-md-12 col-12">
            <button className="btn btn-accept-order" onClick={() => {navigate("/order-new")}} type="button">Предложить заказ</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignerCardInfoFull;

